import * as Yup from 'yup';

import { missionCategorySchemaFields } from '../../../components/MissionCategoryAutocomplete/schemas/mission-category.schema';

export const ResolvableMissionTypeInfoSchema = Yup.object().shape({
  label: Yup.string().required('Libellé requis'),
  title: Yup.string().optional().nullable().default(undefined),
  content: Yup.string().optional().nullable().default(undefined),
  ...missionCategorySchemaFields,
  codingConfig: Yup.object()
    .shape({
      code: Yup.string().required('Code requis'),
    })
    .required('Code requis'),
});
